import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const getRequiredDocuments = async (query) => {
  try {
    const params = new URLSearchParams();
    if (query?.fromSupplier !== undefined) params.set('fromSupplier', query.fromSupplier);
    if (query?.fromMaster !== undefined) params.set('fromMaster', query.fromMaster);
    if (query?.supplierId != null) params.set('supplierId', query.supplierId);
    if (query?.tierType) params.set('tierType', query.tierType);
    return await apiClient.get(`${apiEndpoint}${API.REQUIRED_DOCUMENT.DOC_TYPE}?${params.toString()}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addDocument = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.REQUIRED_DOCUMENT.DOC_TYPE}`, { documentTypes: payload });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateDocumentTypeSequence = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.REQUIRED_DOCUMENT.DOC_TYPE}`, { documentTypes: payload });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteDocument = async (id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.REQUIRED_DOCUMENT.DOC_TYPE}`, { data: { docId: id } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// *****userGroupsCards******
export const getUserGroupsCardList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USER_RIGHTS.GET_USERS_GROUPS_CARD}`, {
      params: {
        sortByPropertyName: data?.sortByPropertyName,
        sortOrder: data?.sortOrder,
        searchText: data?.searchText,
        fromPCP: data?.fromPCP,
      },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addUserGroupsCardList = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.USER_RIGHTS.POST_USERS_GROUPS_CARD}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteUserGroupsCardList = async (id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.USER_RIGHTS.DELETE_USERS_GROUPS_CARD}`, { data: { groupId: id } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateUserGroupsCardList = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.USER_RIGHTS.UPDATE_USERS_GROUPS_CARD}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUserGroupsCardListbyid = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USER_RIGHTS.GET_USERGROUPS_BYID}/rights`, {
      params: {
        groupId: payload.userId,
      },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const updateUserGroups = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.USER_RIGHTS.PUT_USERGROUPS}/${payload?.userId}/rights`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// *****userGroupsCards******
export const getUserLibraryList = async (data) => {
  try {
    const params = {
      sortByPropertyName: data?.sortByPropertyName,
      sortOrder: data?.sortOrder,
      searchText: data?.searchText,
    };
    if (data?.pageIndex !== undefined) {
      params.pageIndex = data.pageIndex;
      params.pageSize = data.pageSize;
    }
    return await apiClient.get(`${apiEndpoint}${API.USER_LIBRARY.GET_USERS_LIBRARY_LIST}`, { params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSupplierUsersList = async (data) => {
  try {
    const params = {
      supplierId: data?.supplierId,
      searchText: data?.queryParam?.searchText,
      sortByPropertyName: data?.queryParam?.sortByPropertyName,
      sortOrder: data?.queryParam?.sortOrder,
    };
    if (data?.queryParam?.pageIndex !== undefined) {
      params.pageIndex = data.queryParam.pageIndex;
      params.pageSize = data.queryParam.pageSize;
    }
    return await apiClient.get(`${apiEndpoint}${API.USER_LIBRARY.GET_SUPPLIER_USERS_LIST}`, { params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteUsersLibrary = async (id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.USER_LIBRARY.DELETE_USERS_LIBRARY}`, { userId: id });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const updateUsersStatus = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.USER_LIBRARY.UPDATE_USERS_LIBRARY_STATUS}/${payload?.userId}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const updateUsersLibrary = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.USER_LIBRARY.UPDATE_USERS_LIBRARY}/${payload?.userId}/rights`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updatePassword = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USER_LIBRARY.RESET_USERS_PASSWORD}`, {
      params: {
        checkFor: payload?.checkFor,
        email: payload?.email,
        userId: payload?.userId,
      },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addUserService = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.USER_LIBRARY.ADD_USER}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const updateUsersDetails = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.USER_LIBRARY.EDIT_USERS}/${payload?.userId}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// get user subscription detail services
export const companySubscriptions = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USER_RIGHTS.GET_COMPANY_SUBSCRIPTION_DETAILS}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
